import IconButton from '@/components/Buttons/IconButton';
import { createTranslationModalOpen } from '@/pages/translation/state';
import { useFlag } from '@/services/featureFlags';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { Close } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { useSetRecoilState } from 'recoil';

const CloseButton = styled(IconButton)`
    width: fit-content;
    position: absolute;
    right: 1.2rem;
    top: 1rem;
`;

const CloseIcon = styled(Close)`
    font-size: 24px;
    color: ${({ theme }) => theme.colors.secondary[600]};
`;

const Subtitle = styled(Typography)`
    margin-top: 1rem;
    margin-bottom: 3rem;
`;

interface HeaderProps {
    onClose: () => void;
}

export const Header = ({ onClose }: HeaderProps) => {
    const theme = useTheme();

    const setOpen = useSetRecoilState(createTranslationModalOpen);
    const shouldEnableLongTranslations = useFlag('enable_long_translation', false);

    const maxDurationInMinutes = shouldEnableLongTranslations ? 30 : 5;
    return (
        <>
            <CloseButton
                ariaLabel="translation-dialog-close"
                onClick={() => {
                    setOpen(false);
                    onClose();
                }}>
                <CloseIcon htmlColor={theme.colors.secondary.main} />
            </CloseButton>
            <Typography variant="h2">Upload a video to translate</Typography>
            <Subtitle variant="body1">
                Video footage must be between <strong> 10 seconds and {maxDurationInMinutes} minutes.</strong>
            </Subtitle>
        </>
    );
};
